import initializeWCAG from './wcag';
import initializeMobileMenu from './mobile-menu';
import initializeFiles from './blocks/files';
import initializeFancyBox from './fancybox';
import initializeForm from './utils/form';
import initializeMenu from "./menu";
import initializeImageSlider from './blocks/image-slider';
import initializeTextContainer from "./blocks/text-container";
import initializeBip from "./bip";
import initializeVentiTabs from "./blocks/venti-tabs";
import initializeAccordions from "./blocks/accordion";
import 'what-input';

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 1000
            });
        });
        initializeTextContainer();
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeMenu();
        initializeFiles();
        initializeWCAG();
        initializeImageSlider();
        initializeBip();
        initializeVentiTabs();
        initializeAccordions();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
